var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-navi-header-container" },
    [
      _c("transition", { attrs: { name: "global-navi-overlay-fade" } }, [
        _vm.showSideMenu
          ? _c("div", {
              staticClass: "global-navi-overlay",
              on: { click: _vm.onSideMenuClose },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "global-navi-header-inner" }, [
        _c(
          "div",
          { staticClass: "global-navi-header" },
          [
            _c(
              "div",
              { staticClass: "global-navi-title-label global-navi-logo" },
              [_c("service-logo", [_vm._t("default")], 2)],
              1
            ),
            _vm._v(" "),
            _vm.showBeautydayButtonTerm1
              ? _c(
                  "div",
                  { staticClass: "global-navi-beautyday-logo" },
                  [_c("beautyday-button-term1")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showBeautydayButtonTerm2
              ? _c(
                  "div",
                  { staticClass: "global-navi-beautyday-logo" },
                  [_c("beautyday-button-term2")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showBeautydayButtonTerm3
              ? _c(
                  "div",
                  { staticClass: "global-navi-beautyday-logo" },
                  [_c("beautyday-button-term3")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showBeautydayButtonTerm4
              ? _c(
                  "div",
                  { staticClass: "global-navi-beautyday-logo" },
                  [_c("beautyday-button-term4")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "global-navi-header-navi-list" }, [
              _vm.$store.getters["context/ready"]
                ? _c(
                    "ul",
                    { staticClass: "global-navi-header-navi-list-items" },
                    [
                      _vm.showHomeButton
                        ? _c(
                            "li",
                            { staticClass: "global-navi-top-link-btn" },
                            [_c("home-button")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSearchButton
                        ? _c(
                            "li",
                            { staticClass: "global-navi-search-btn" },
                            [
                              _c("search-button", {
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("search-button-clicked")
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.viewerId && _vm.loginUrl
                        ? _c(
                            "li",
                            { staticClass: "global-navi-account-btn" },
                            [_c("my-button")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.viewerId && _vm.loginUrl
                        ? _c(
                            "li",
                            { staticClass: "global-navi-login-btn" },
                            [
                              _c("login-button", {
                                attrs: { "login-url": _vm.loginUrl },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showMenuButton
                        ? _c(
                            "li",
                            { staticClass: "global-navi-menu-btn" },
                            [
                              _c("menu-button", {
                                directives: [
                                  {
                                    name: "analytics",
                                    rawName: "v-analytics",
                                    value: { label: "header_side_menu" },
                                    expression: "{label:'header_side_menu'}",
                                  },
                                ],
                                on: { click: _vm.onSideMenuOpen },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.showMenuButton
              ? _c(
                  "transition",
                  {
                    attrs: { name: "bounce" },
                    on: {
                      "after-enter": _vm.onSideMenuOpened,
                      "after-leave": _vm.onSideMenuClosed,
                    },
                  },
                  [
                    _c("side-menu", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showSideMenu,
                          expression: "showSideMenu",
                        },
                      ],
                      ref: "sideMenu",
                      attrs: {
                        "login-url": _vm.loginUrl,
                        active: _vm.showSideMenu,
                      },
                      on: { "content-changed": _vm.onSideMenuContentChanged },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showNaviInfo
        ? _c("div", { staticClass: "global-navi-header-info" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }